export var MUIX_TABLE_PREFERENCE;
(function (MUIX_TABLE_PREFERENCE) {
    MUIX_TABLE_PREFERENCE["STORY_BOOK_TEST"] = "STORY_BOOK_TEST";
})(MUIX_TABLE_PREFERENCE || (MUIX_TABLE_PREFERENCE = {}));
export var MUIX_SCREEN_PREFERENCE;
(function (MUIX_SCREEN_PREFERENCE) {
    MUIX_SCREEN_PREFERENCE["STORY_BOOK_TEST"] = "STORY_BOOK_TEST";
})(MUIX_SCREEN_PREFERENCE || (MUIX_SCREEN_PREFERENCE = {}));
export const DEFAULT_STORY_BOOK_TABLE_COLUMNS = [
    { name: 'sensorId', order: 0 },
    { name: 'sensorAlias', order: 1 },
    { name: 'dataSourceType', order: 2 },
    { name: 'lastValue', order: 3 },
    { name: 'unit', order: 4 },
];
